export default __webpack_public_path__ + "static/media/profile.d9b54df8.jpg";